import { AfterViewInit, Component, ElementRef, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { FMenu } from 'src/app/commons/kymw02/function-menu/fmenu';
import { FunctionMenuService } from 'src/app/commons/kymw02/function-menu/function-menu.service';
import { NotNullTextInputComponent } from 'src/app/commons/kymw02/not-null-text-input/not-null-text-input.component';
import { RadioLabelComponent } from 'src/app/commons/kymw02/radio-label/radio-label.component';
import { NotNullTextAreaComponent } from 'src/app/commons/kymw02/not-null-text-area/not-null-text-area.component';
import { KYMW0300Component } from 'src/app/commons/kymw03/kymw0300/kymw0300.component';
import { PlessDialogServiceSub } from 'src/app/commons/kymw00/pless-dialog-service-sub';
import { KYMW0300InputModel } from 'src/app/commons/kymw03/kymw0300/vo/kymw0300-input.model';
import { KYMW0300OutputModel } from 'src/app/commons/kymw03/kymw0300/vo/kymw0300-output.model';
import { PlessViewHelperSub } from 'src/app/commons/kymw00/pless-view-helper-sub';
import { KYMW00Model } from 'src/app/commons/kymw00/kymw00.model';
import { CwsPlanCategoryCodeComboBoxComponent } from 'src/app/commons/kymw02/combo-box/cws-plan-category-code-combo-box/cws-plan-category-code-combo-box.component';
import { GroupingCodeComboBoxComponent } from 'src/app/commons/kymw02/combo-box/grouping-code-combo-box/grouping-code-combo-box.component';
import { CatalogProgressTextInputComponent } from 'src/app/commons/kymw02/text-input/catalog-progress-text-input/catalog-progress-text-input.component';
import { SmallClassCodeComboBoxComponent } from 'src/app/commons/kymw02/combo-box/small-class-code-combo-box/small-class-code-combo-box.component';
import { CheckNgWordsService } from 'src/app/commons/kymw02/check-ng-words/api-services/check-ng-words.service';
import { KYMW0E00InputModel } from 'src/app/commons/kymw0e/kymw0e00/vo/kymw0e00-input.model';
import { KYMW0E00Component } from 'src/app/commons/kymw0e/kymw0e00/kymw0e00.component';
import { KYMW0E00OutputModel } from 'src/app/commons/kymw0e/kymw0e00/vo/kymw0e00-output.model';
import { KYMW0900Component } from 'src/app/commons/kymw09/kymw0900/kymw0900.component';
import { KYMW0900InputModel } from 'src/app/commons/kymw09/kymw0900/vo/kymw0900-input.model';
import { KYMW0900OutputModel } from 'src/app/commons/kymw09/kymw0900/vo/kymw0900-output.model';
import { KYMW0F00Component } from 'src/app/commons/kymw0f/kymw0f00/kymw0f00.component';
import { KYMW0F00OutputModel } from 'src/app/commons/kymw0f/kymw0f00/vo/kymw0f00-output.model';
import { KYMW0F00InputModel } from 'src/app/commons/kymw0f/kymw0f00/vo/kymw0f00-input.model';
import { KYMW5002Component } from 'src/app/commons/kymw50/kymw5002/kymw5002.component';
import { KYMW5002OutputModel } from 'src/app/commons/kymw50/kymw5002/vo/kymw5002-output.model';
import { KYMW5002InputModel } from 'src/app/commons/kymw50/kymw5002/vo/kymw5002-input.model';
import { KYMW0002Component } from 'src/app/commons/kymw00/kymw0002/kymw0002.component';
import { KYMW0003Component } from 'src/app/commons/kymw00/kymw0003/kymw0003.component';
import { KYMW1202Component } from 'src/app/kymw/kymw12/kymw1202/kymw1202.component';
import { KYMW1503Component } from '../kymw15/kymw1503/kymw1503.component';
import { KYMW1504Component } from '../kymw15/kymw1504/kymw1504.component';
import { KYMW1505Component } from 'src/app/kymw/kymw15/kymw1505/kymw1505.component';
import { KYMW1506Component } from 'src/app/kymw/kymw15/kymw1506/kymw1506.component';
import { KYMW1507Component } from 'src/app/kymw/kymw15/kymw1507/kymw1507.component';
import { KYMW1507InputModel } from 'src/app/kymw/kymw15/kymw1507/vo/kymw1507-input.model';
import { KYMW1508Component } from 'src/app/kymw/kymw15/kymw1508/kymw1508.component';
import { KYMW1508InputModel } from 'src/app/kymw/kymw15/kymw1508/vo/kymw1508-input.model';
import { KYMW1509Component } from 'src/app/kymw/kymw15/kymw1509/kymw1509.component';
import { KYMW1510Component } from 'src/app/kymw/kymw15/kymw1510/kymw1510.component';
import { KYMW1510InputModel } from 'src/app/kymw/kymw15/kymw1510/vo/kymw1510-input.model';
import { KYMW1705Component } from '../kymw17/kymw1705/kymw1705.component';
import { KYMW1706Component } from '../kymw17/kymw1706/kymw1706.component';
import { KYMW1709Component } from '../kymw17/kymw1709/kymw1709.component';
import { KYMW4802Component } from 'src/app/kymw/kymw48/kymw4802/kymw4802.component';
import { KYMW4802InputModel } from 'src/app/kymw/kymw48/kymw4802/vo/kymw4802-input.model';
import { KYMW4802OutputModel } from 'src/app/kymw/kymw48/kymw4802/vo/kymw4802-output.model';
import { KYMW2000Component } from 'src/app/kymw/kymw20/kymw2000/kymw2000.component';
import { PlessAlert } from '../../shared/pless-alert/pless-alert.component';
import { KYMW0600Component } from 'src/app/commons/kymw06/kymw0600/kymw0600.component';
import { KYMW0600OutputModel } from 'src/app/commons/kymw06/kymw0600/vo/kymw0600-output.model';
import { KYMW0001Component } from 'src/app/commons/kymw00/kymw0001/kymw0001.component';
import { KYMW9006Component } from '../kymw90/kymw9006/kymw9006.component';
import { KYMW1318Component } from '../kymw13/kymw1318/kymw1318.component';
import { KYMW1318InputModel } from 'src/app/kymw/kymw13/kymw1318/vo/kymw1318-input.model';
import { KYMW0400InputModel } from 'src/app/commons/kymw04/kymw0400/vo/kymw0400-input.model';
import { KYMW0400Component } from 'src/app/commons/kymw04/kymw0400/kymw0400.component';
import { KYMW0400OutputModel } from 'src/app/commons/kymw04/kymw0400/vo/kymw0400-output.model';
import { KYMW1707Component } from '../kymw17/kymw1707/kymw1707.component';
import { KYMW0B00Component } from 'src/app/commons/kymw0b/kymw0b00/kymw0b00.component';
import { KYMW0B00Model } from 'src/app/commons/kymw0b/kymw0b00/kymw0b00.model';
import { KYMW0B00InputModel } from 'src/app/commons/kymw0b/kymw0b00/vo/kymw0b00-input.model';
import { KYMW0B00OutputModel } from 'src/app/commons/kymw0b/kymw0b00/vo/kymw0b00-output.model';
import { KYMW1708Component } from '../kymw17/kymw1708/kymw1708.component';
import { KYMW7401Component } from '../kymw74/kymw7401/kymw7401.component';
import { KYMW7401OutputModel } from '../kymw74/kymw7401/vo/kymw7401-output.model';
import { KYMW7403Component } from '../kymw74/kymw7403/kymw7403.component';
import { KYMW1317Component } from '../kymw13/kymw1317/kymw1317.component';
import { KYMW1108Component } from '../kymw11/kymw1108/kymw1108.component';
import { KYMW1108InputModel } from '../kymw11/kymw1108/vo/kymw1108-input.model';
import { KYMW1319Component } from '../kymw13/kymw1319/kymw1319.component';
import { KYMW1319InputVO } from '../kymw13/kymw1319/vo/kymw1319-inputVO.model';
import { KYMW0906Component } from 'src/app/commons/kymw09/kymw0906/kymw0906.component';
import { KYMW0906InputModel } from 'src/app/commons/kymw09/kymw0906/vo/kymw0906-input.model';
import { KYMW0906OutputModel } from 'src/app/commons/kymw09/kymw0906/vo/kymw0906-output.model';

@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.scss']
})
export class TestComponent extends PlessViewHelperSub implements OnInit, AfterViewInit {
  @ViewChild('txti_CorrectMemberName', { static: true }) txti_CorrectMemberName: NotNullTextInputComponent;
  @ViewChild('txti_CorrectAnonymous', { static: true }) txti_CorrectAnonymous: NotNullTextInputComponent;
  @ViewChild('rdbg_Coop', { static: true }) rdbg_Coop: RadioLabelComponent;
  @ViewChild('rdbg_Center', { static: true }) rdbg_Center: RadioLabelComponent;
  @ViewChild('txti_CenterName', { static: true }) txti_CenterName: NotNullTextInputComponent;
  @ViewChild('txta_InquiryContents', { static: true }) txta_InquiryContents: NotNullTextAreaComponent;
  @ViewChild('cmbCwsPlanCategoryCode', { static: true }) cmbCwsPlanCategoryCode: CwsPlanCategoryCodeComboBoxComponent;
  @ViewChild('cmbGroupingCode', { static: true }) cmbGroupingCode: GroupingCodeComboBoxComponent;
  @ViewChild('txtCatalogProgress', { static: true }) txtCatalogProgress: CatalogProgressTextInputComponent;
  @ViewChild('cmbSmallClassCode', { static: true }) cmbSmallClassCode: SmallClassCodeComboBoxComponent;

  // コンボボックス テスト用
  public comboTestVal = '001';
  public comboTestList = [
    { code: '001', val: 'テスト１' },
    { code: '002', val: 'テスト２' },
  ];

  constructor(
    private router: Router,
    private fmenuService: FunctionMenuService,
    private dialogService: PlessDialogServiceSub,
    private viewContainerRef: ViewContainerRef,
    public kymw00Model: KYMW00Model,
    private checkNgWordsService: CheckNgWordsService,
  ) {
    super(kymw00Model);
  }

  ngOnInit(): void {
    this.componentName = 'KYMWTEST1';

    const menu1 = new FMenu('#menu1', {
      header: 'メニュー1',
      itemsSource: [
        { header: '項目1', menuID: 'mi_Item1' },
        { header: '項目2', menuID: 'mi_Item2' },
      ],
      command: this.getFormatMenuCommand(),
      itemClicked: () => {
        this.eventMenuClickHander(menu1)
      }
    });

    const menu2 = new FMenu('#menu2', {
      header: 'メニュー2',
      itemsSource: [
        { header: '項目3', menuID: 'mi_Item3' },
      ],
      command: this.getFormatMenuCommand(),
      itemClicked: () => {
        this.eventMenuClickHander(menu2)
      }
    });

    const menu3 = new FMenu('#menu3', {
      header: 'メニュー3',
      itemsSource: [
        { header: '長い長い長い長い<br/>ながいながい項目名4', menuID: 'mi_Item4' },
        { header: '項目5', menuID: 'mi_Item5', enabled: true },
        { header: '項目6', menuID: 'mi_Item6', enabled: false },
        { header: '項目7', menuID: 'mi_Item7' },
        { header: '項目8', menuID: 'mi_Item8' },
        { header: '項目9', menuID: 'mi_Item9' },
        { header: '項目10', menuID: 'mi_Item10' },
        { header: '項目11', menuID: 'mi_Item11' },
        { header: '項目12', menuID: 'mi_Item12' },
        { header: '項目13', menuID: 'mi_Item13' },
        { header: '項目14', menuID: 'mi_Item14' },
        { header: '項目15', menuID: 'mi_Item15' },
        { header: '項目16', menuID: 'mi_Item16' },
        { header: '項目17', menuID: 'mi_Item17' },
        { header: '項目18', menuID: 'mi_Item18' },
        { header: '項目19', menuID: 'mi_Item19' },
        { header: '項目20', menuID: 'mi_Item20' },
        { header: '項目21', menuID: 'mi_Item21' },
      ]
    });

    this.fmenuService.menus = [menu1, menu2, menu3];

    //    this.checkNgWordsService.execute({}, { itemName: 'キャッチコピー', string: '奉納' });

    this.cmbCwsPlanCategoryCode.selectedOrderCode = '2018110';
    //    this.cmbCwsPlanCategoryCode.updateCategoryList();

    //    this.cmbGroupingCode.reload();
  }

  ngAfterViewInit(): void {
    this.cmbSmallClassCode.reload('1009');
  }

  private getFormatMenuCommand(): any {
    return {
      canExecuteCommand: (item) => {
        switch (item.menuID) {
          case 'mi_Item1':
            return false;
          default:
            return true;
        }
      }
    };
  }

  private eventMenuClickHander(menu: FMenu): void {
    alert(menu.selectedItem.menuID);
  }

  public eventSeach_CLICKHandler(): void {
    const input = new KYMW0300InputModel();

    let kymw0300ComponentRef: any;
    kymw0300ComponentRef =
      this.dialogService.openModelessSub(
        this, KYMW0300Component,
        this.viewContainerRef, kymw0300ComponentRef, null, 0, '', true);

    if (kymw0300ComponentRef != null) {
      const kymw0300Component = kymw0300ComponentRef.instance as KYMW0300Component;
      kymw0300Component.parent = this;
      kymw0300Component.setInterfaceParam(input);
      kymw0300Component.setKYMW0300Parameter =
        (outputVO: KYMW0300OutputModel) => {
          console.log(outputVO);
        };

      kymw0300Component.closeFunction = () => {
        kymw0300ComponentRef.destroy();
      };
    }
  }

  public eventKYMW0400_CLICKHandler(isMultiCheckable: boolean): void {
    // 「商品検索ポップアップ用インプットVO」の生成
    const vo: KYMW0400InputModel = { supplierFlg: null, isMultiCheckable: isMultiCheckable };
    const componentRef = this.dialogService.openModal(KYMW0400Component);
    const instance = componentRef.componentInstance as KYMW0400Component;
    instance.parent = this;
    instance.setInterfaceParam(vo);
    instance.closeFunction = () => {
      componentRef.close();
    };
    instance.setKYMW0400Parameter = (outputVO: KYMW0400OutputModel) => {
      console.log(outputVO);
    };
  }

  public eventKYMW0E00_CLICKHandler(): void {
    const inputVo: KYMW0E00InputModel = new KYMW0E00InputModel();
    inputVo.processDiv = 1;
    inputVo.imageID = '674700';
    inputVo.startOrderCodeBefore = '2023110';
    inputVo.startOrderCodeAfter = '2023440';
    inputVo.imageName = 'P2648950B';
    inputVo.imageFileName = 'P2648950B_01';

    const componentRef = this.dialogService.openModal(KYMW0E00Component);
    const instance = componentRef.componentInstance as KYMW0E00Component;
    instance.parent = this;
    instance.setInterfaceParam(inputVo);
    instance.setKYMW0E00Parameter = (outputVO: KYMW0E00OutputModel) => {
    };
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  public eventKYMW0900_CLICKHandler(): void {
    const vo: KYMW0900InputModel = {
      MediumType: "001",
      UserPermission: "0",
      lockInfo: "0",
      orderCode: "2023320",
      pCodeList: ['P2670878'],
      bundleCatalogOrderCode: '20231001'
    };
    const componentRef = this.dialogService.openModal(KYMW0900Component);
    const instance = componentRef.componentInstance as KYMW0900Component;
    instance.setInterfaceParam(vo);
    instance.setKYMW0900Parameter = (outputVO: KYMW0900OutputModel) => { };

    // ウィンドウが閉じられる際の処理
    instance.parent = this;
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  public eventKYMW0F00_CLICKHandler(): void {
    const vo: KYMW0F00InputModel = new KYMW0F00InputModel;

    vo.EnableCoop142 = true ? '0' : '2';
    vo.EnableCoop163 = false ? '0' : '2';
    vo.EnableCoop185 = true ? '0' : '2';
    vo.EnableCoop240 = false ? '0' : '2';
    vo.EnableCoop210 = true ? '0' : '2';
    vo.EnableCoop302 = false ? '0' : '2';
    vo.EnableCoop515 = true ? '0' : '2';
    vo.EnableCoop451 = false ? '0' : '2';

    const componentRef = this.dialogService.openModal(KYMW0F00Component);
    const instance = componentRef.componentInstance as KYMW0F00Component;
    instance.parent = this;
    instance.setKYMW0F00Parameter = (outputVO: KYMW0F00OutputModel) => {
      console.log(outputVO.groupingCode);
    };
    instance.setInterfaceParam(vo);
    instance.closeFunction = () => {
      componentRef.close();
    }
  }

  public eventKYMW5002_CLICKHandler(): void {
    const vo: KYMW5002InputModel = {
      flg: '2',
      orderCode: '2023250',
      pcode: 'P2662170',
      pushCoopCode: '',
      goodsName: 'めばちまぐろ切り落とし',
      goodsStandardName: '５０ｇ×２',
      enableCoopCodeVOList: [
        { 'enableCoopCode': '142' },
        { 'enableCoopCode': '163' },
        { 'enableCoopCode': '185' },
        { 'enableCoopCode': '240' },
        { 'enableCoopCode': '210' },
        { 'enableCoopCode': '302' },
        { 'enableCoopCode': '515' },
        { 'enableCoopCode': '451' },
      ],
      selectCoopInfoVOList: [
        { 'selectCoopCode': '142' },
      ],
      useImageInfoVOList: [
        {
          ImageFileName: 'P2662170A_01',
          ImageId: 635286,
          ImageName: 'P2662170A',
          ImageURL: 'http://127.0.0.1:8083/N_PEACE/file/image//IMG_589/P2662169A_01.png',
          ShowSeq: '1',
          StartOrderCode: '2022330',
          TextCaption: '',
        },
        {
          ImageFileName: 'P2662170C_02',
          ImageId: 635288,
          ImageName: 'P2662170C',
          ImageURL: 'http://127.0.0.1:8083/N_PEACE/file/image//IMG_589/P2662170C_02M.jpg',
          ShowSeq: '2',
          StartOrderCode: '2022330',
          TextCaption: '',
        },
        {
          ImageFileName: 'P2662170C_06',
          ImageId: 671336,
          ImageName: 'P2662170C',
          ImageURL: 'http://127.0.0.1:8083/N_PEACE/file/image//IMG_623/P2662170C_06M.jpg',
          ShowSeq: '3',
          StartOrderCode: '2022330',
          TextCaption: '８頁　ばくだん丼　・めばちまぐろ切り落とし　・北海道産大豆の小粒納豆カップ　・手間なし！加熱いらず　',
        },
        {
          ImageFileName: 'P2662170C_05',
          ImageId: 635291,
          ImageName: 'P2662170C',
          ImageURL: 'http://127.0.0.1:8083/N_PEACE/file/image//IMG_589/P2662170C_05M.jpg',
          ShowSeq: '4',
          StartOrderCode: '2022330',
          TextCaption: '',
        }
      ],
    } as KYMW5002InputModel;

    const componentRef = this.dialogService.openModal(KYMW5002Component);
    const instance = componentRef.componentInstance as KYMW5002Component;
    instance.parent = this;
    instance.setInterfaceParam(vo);
    instance.setKYMW5002Parameter = (outputVO: KYMW5002OutputModel) => {
      console.log(outputVO);
    };
    instance.closeFunction = () => {
      componentRef.close();
    };
  }


  // 掲載媒体設定モーダル表示
  public eventKYMW1202_CLICKHandler(): void {
    const componentRef = this.dialogService.openModal(KYMW1202Component);
    const instance = componentRef.componentInstance as KYMW1202Component;
    instance.parent = this;
    instance.setParams({ pCode: 'P2621424' });
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  public eventKYMW2000_CLICKHandler(): void {
    const componentRef = this.dialogService.openModal(KYMW2000Component);
    const instance = componentRef.componentInstance as KYMW2000Component;
    instance.parent = this;
    instance.setParams({ funcID: 'KYMW1200', mediumType: '002', orderCode: '' });
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  // マーク登録
  public eventKYMW1503_CLICKHandler(): void {
    const componentRef = this.dialogService.openModal(KYMW1503Component);
    const instance = componentRef.componentInstance as KYMW1503Component;

    instance.parent = this;
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  // マークファイル登録モーダル表示
  public eventKYMW1504_CLICKHandler(): void {
    const componentRef = this.dialogService.openModal(KYMW1504Component);
    const instance = componentRef.componentInstance as KYMW1504Component;

    instance.parent = this;
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  // タグ選択モーダル表示
  public eventKYMW0002_CLICKHandler(): void {
    const componentRef = this.dialogService.openModal(KYMW0002Component);
    const instance = componentRef.componentInstance as KYMW0002Component;
    instance.parent = this;
    instance.setParams(['00000001', '00000002']);
    instance.closeFunction = () => {
      console.log('KYMW0002 output', instance.getParams());
      componentRef.close();
    };
  }

  // 関連Pコードモーダル
  public eventKYMW0600_CLICKHandler(): void {
    // 関連商品画面を起動
    const componentRef = this.dialogService.openModal(KYMW0600Component);
    const instance = componentRef.componentInstance as KYMW0600Component;
    instance.parent = this;
    instance.setInterfaceParam({ pCode: "P0000302" });
    // instance.setKYMW0600Parameter = (outputVO: KYMW0600OutputModel) => this.setKYMW0600Parameter(outputVO);
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  public eventKYMW0003_CLICKHandler(): void {
    const componentRef = this.dialogService.openModal(KYMW0003Component);
    const instance = componentRef.componentInstance as KYMW0003Component;
    instance.parent = this;
    instance.closeFunction = () => {
      console.log('KYMW0003 output', instance.getParams());
      componentRef.close();
    };
  }

  public eventKYMW7007_CLICKHandler(): void {
    this.router.navigate(['/kymw/7007'], {
      queryParams: { orderCode: '2023300', mediumType: '003' },
    });
  }

  public eventKYMW1201_CLICKHandler(): void {
    this.router.navigate(['/kymw/1201'], {
      queryParams: { orderCode: '2023300', mediumType: '003' },
    });
  }

  public eventKYMW7402_CLICKHandler(): void {
    const instance =
    this.router.navigate(['/kymw/7402'], {
      queryParams: { itemCode: '1234567' , rememberGoodsId: '12345678'},
    });
  }

  public eventKYMW6001_CLICKHandler(): void {
    this.router.navigate(['/kymw/6001'], {
      queryParams: {
        orderCode: '2023300',
        mediumType: '003',
        mediumName: '媒体1',
        catalogId: '2023240',
        classCode: '03',
        className: '部門1',
        pCode: 'P2660232',
        featureCode: '',
        featureName: '',
        multiOrCrossFlg: 'true',
        imageNoUseFlag: 'true',
        imageCheckFlag: 'true',
        startDispNum: '1',
      },
    });
  }

  public eventKYMW1505_CLICKHandler(): void {
    const componentRef = this.dialogService.openModal(KYMW1505Component);
    const instance = componentRef.componentInstance as KYMW1505Component;
    instance.parent = this;
    instance.setInterfaceParam('01');
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  public eventKYMW1506_CLICKHandler(): void {
    const componentRef = this.dialogService.openModal(KYMW1506Component);
    const instance = componentRef.componentInstance as KYMW1506Component;
    instance.parent = this;
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  public eventKYMW1507_CLICKHandler(): void {
    const vo: KYMW1507InputModel = {
      iconCode: '123',
      iconCodeBranch: '01',
    }

    const componentRef = this.dialogService.openModal(KYMW1507Component);
    const instance = componentRef.componentInstance as KYMW1507Component;
    instance.parent = this;
    instance.setInterfaceParam(vo);
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  public eventKYMW1508_CLICKHandler(): void {
    const vo: KYMW1508InputModel = {
      iconCode: '123',
    }

    const componentRef = this.dialogService.openModal(KYMW1508Component);
    const instance = componentRef.componentInstance as KYMW1508Component;
    instance.parent = this;
    instance.setInterfaceParam(vo);
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  public eventKYMW1509_CLICKHandler(): void {
    const componentRef = this.dialogService.openModal(KYMW1509Component);
    const instance = componentRef.componentInstance as KYMW1509Component;
    instance.parent = this;
    instance.setInterfaceParam('01');
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  public eventKYMW1510_CLICKHandler(): void {
    const vo: KYMW1510InputModel = {
      iconCode: '123',
      iconCodeBranch: '01',
    }

    const componentRef = this.dialogService.openModal(KYMW1510Component);
    const instance = componentRef.componentInstance as KYMW1510Component;
    instance.parent = this;
    instance.setInterfaceParam(vo);
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  public eventKYMW4802_CLICKHandler(): void {
    const vo: KYMW4802InputModel = {
      mediumType: '001',
      mediumName: 'ハピデリ',
      catalogId: '20231002',
      orderCode: '2023300',
      pcode: 'P2230364',
      guideGoodsName: '極小粒納豆カップ４',
      guidsStandardName: '３０ｇ×４たれ・からし付'
    }

    const componentRef = this.dialogService.openModal(KYMW4802Component);
    const instance = componentRef.componentInstance as KYMW4802Component;
    instance.parent = this;
    instance.setInterfaceParam(vo);
    instance.setKYMW4802Parameter = (outputVo: KYMW4802OutputModel) => {
      console.log(outputVo);
    };
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  public open_ScreenDialog(): void {
    this.eventKYMW0900_CLICKHandler();
  }

  public open_AlertDialog(): void {
    this.dialogService.openAlertGetMessage('W0001', ['受注コード'], () => {
      this.dialogService.openAlertGetMessage("E0100", [''], () => {
        this.dialogService.openAlertGetMessage('Q0109', null, (closeDetail) => {
          this.dialogService.openAlertGetMessage('I0106', ['テンプレートを更新'], () => {
            this.dialogService.openAlert('データのロックに失敗しました', 'E', [PlessAlert.Yes_Error], () => {
              this.dialogService.openAlertGetMessage('S0101', ['']);
            });
          });
        });
      });
    });
  }

  public eventKYMW9007_CLICKHandler(): void {
    // テスト画面からログイン画面まで遷移し、ログインし直すとkymw1002にテスト画面のサイドメニューが表示されてしまうため、
    // kymw.component.tsのlogout()で記載している「サイドメニューを空にする」処理を追加
    // テスト画面は本番環境では見えない画面だが、開発時に混乱が起きないようにするため
    this.fmenuService.menus = [];
    this.router.navigate(['/kymw/9007'], {});
  }

  public eventKYMW9008_CLICKHandler(): void {
    // テスト画面からログイン画面まで遷移し、ログインし直すとkymw1002にテスト画面のサイドメニューが表示されてしまうため、
    // kymw.component.tsのlogout()で記載している「サイドメニューを空にする」処理を追加
    // テスト画面は本番環境では見えない画面だが、開発時に混乱が起きないようにするため
    this.fmenuService.menus = [];
    this.router.navigate(['/kymw/9008'], {});
  }

  public eventKYMW9006_CLICKHandler(): void {
    // パスワード変更ダイアログ
    const componentRef = this.dialogService.openModal(KYMW9006Component);
    const instance = componentRef.componentInstance as KYMW9006Component;
    instance.parent = this;
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  public eventKYMW1318_CLICKHandler(): void {
    const vo: KYMW1318InputModel = {
      orderCode: '2024010',
      pCode: 'P1234567',
      guideGoodsName: 'ｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗ',
      guideStandardName: 'ｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗ',
      mediumType: '001',
      mediumTypeList: [],
    }

    // 受注コード指定選定解除
    const componentRef = this.dialogService.openModal(KYMW1318Component);
    const instance = componentRef.componentInstance as KYMW1318Component;
    instance.parent = this;
    instance.setInterfaceParam(vo);
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  // 忘れず注文商品リスト出力
  public eventKYMW7403_CLICKHandler() {
    const componentRef = this.dialogService.openModal(KYMW7403Component);
    const instance = componentRef.componentInstance as KYMW7403Component;
    instance.parent = this;
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  // マーク選択モーダル表示
  public eventKYMW0001_CLICKHandler(): void {
    const componentRef = this.dialogService.openModal(KYMW0001Component);
    const instance = componentRef.componentInstance as KYMW0001Component;
    instance.setParams({
      orderCode: "2023290",
      windowOpenFlg: 1,
      inputParam: ['001', '002'],
    });
    instance.closeFunction = () => {
      console.log('KYMW0001 output', instance.getParams());
      componentRef.close();
    };
  }

  // 過去画像登録画面表示
  @ViewChild('txt_param1705_imageId', { static: true }) txt_param1705_imageId: ElementRef;
  public eventKYMW1705_CLICKHandler(): void {
    const componentRef = this.dialogService.openModal(KYMW1705Component);
    const instance = componentRef.componentInstance as KYMW1705Component;
    instance.setParameter(this.txt_param1705_imageId.nativeElement.value);
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  // 差し戻し理由入力画面表示
  @ViewChild('txt_param1706_guideGoodsName', { static: true }) txt_param1706_guideGoodsName: ElementRef;
  @ViewChild('txt_param1706_guideStandardName', { static: true }) txt_param1706_guideStandardName: ElementRef;
  @ViewChild('txt_param1706_imageFileName', { static: true }) txt_param1706_imageFileName: ElementRef;
  public eventKYMW1706_CLICKHandler(): void {
    const componentRef = this.dialogService.openModal(KYMW1706Component);
    const instance = componentRef.componentInstance as KYMW1706Component;
    instance.setParameter(this.txt_param1706_guideGoodsName.nativeElement.value,
                          this.txt_param1706_guideStandardName.nativeElement.value,
                          this.txt_param1706_imageFileName.nativeElement.value);
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  // 催促メール定型文選択
  @ViewChild('txt_param1707_sampleOrderingName', { static: true }) txt_param1707_sampleOrderingName: ElementRef;
  @ViewChild('txt_param1707_supplierInfo', { static: true }) txt_param1707_supplierInfo: ElementRef;
  @ViewChild('txt_param1707_imageFileName', { static: true }) txt_param1707_imageFileName: ElementRef;
  public eventKYMW1707_CLICKHandler(): void {
    const componentRef = this.dialogService.openModal(KYMW1707Component);
    const instance = componentRef.componentInstance as KYMW1707Component;
    instance.setParameter(this.txt_param1707_sampleOrderingName.nativeElement.value,
                          this.txt_param1707_supplierInfo.nativeElement.value,
                          this.txt_param1707_imageFileName.nativeElement.value);
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  // 複数コード
  @ViewChild('txt_param1708_imageId', { static: true }) txt_param1708_imageId: ElementRef;
  eventKYMW1708_CLICKHandler():void {
    const componentRef = this.dialogService.openModal(KYMW1708Component);
    const instance = componentRef.componentInstance as KYMW1708Component;
    instance.setParameter(this.txt_param1708_imageId.nativeElement.value);
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  // アップロード画像確認
  @ViewChild('txt_param1709_imageFileName', { static: true }) txt_param1709_imageFileName: ElementRef;
  public eventKYMW1709_CLICKHandler(): void {
    const componentRef = this.dialogService.openModal(KYMW1709Component);
    const instance = componentRef.componentInstance as KYMW1709Component;
    instance.setParameter(this.txt_param1709_imageFileName.nativeElement.value);
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  // KYMW7401 忘れず注文商品対象選択 ダイアログ表示
  eventKYMW7401_CLICKHandler() {
    const componentRef = this.dialogService.openModal(KYMW7401Component);
    const instance = componentRef.componentInstance as KYMW7401Component;
    // ダイアログ内「xxx」実行時処理
    instance.setKYMW7401Parameter = (output: KYMW7401OutputModel) => {
      componentRef.close(); // ダイアログを閉じる
    };

    // ウィンドウが閉じられる際の処理
    instance.parent = this;
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  gotoKYMW7002_CreateMode1_CLICKHandler(): void {
    this.router.navigate(['kymw/7002'], {
      queryParams: {
        CatalogIdName: '2025年2月1回',
        OrderCode: '2024470',
        mediumType: '018', // 媒体区分「在庫限定」
        MediumName: 'テスト媒体名（在庫限定）',
        FeatureCode: 'test2',
        FeatureName: 'テスト特集名（新規提案）',
        ViewType: '0', // 新規提案
      }
    })
  }
  gotoKYMW7002_CreateMode2_CLICKHandler(): void {
    this.router.navigate(['kymw/7002'], {
      queryParams: {
        CatalogIdName: '2025年2月2回',
        OrderCode: '2024470',
        mediumType: '019', // 媒体区分「在庫限定」以外
        MediumName: 'テスト媒体名（在庫限定以外）',
        FeatureCode: 'test3',
        FeatureName: 'テスト特集名（新規提案）',
        ViewType: '0', // 新規提案
      }
    })
  }
  gotoKYMW7002_HistoryMode1_CLICKHandler(): void {
    this.router.navigate(['kymw/7002'], {
      queryParams: {
        CatalogIdName: '2025年2月3回',
        OrderCode: '2024480',
        mediumType: '018', // 媒体区分「在庫限定」
        MediumName: 'テスト媒体名（在庫限定）',
        FeatureCode: 'test4',
        FeatureName: 'テスト特集名（履歴確認）',
        ViewType: '1', // 履歴確認
      }
    })
  }
  gotoKYMW7002_HistoryMode2_CLICKHandler(): void {
    this.router.navigate(['kymw/7002'], {
      queryParams: {
        CatalogIdName: '2025年2月4回',
        OrderCode: '2024490',
        mediumType: '019', // 媒体区分「在庫限定」以外
        MediumName: 'テスト媒体名（在庫限定以外）',
        FeatureCode: 'test2',
        FeatureName: 'テスト特集名（履歴確認）',
        ViewType: '1', // 履歴確認
      }
    })
  }
  public eventKYMW9011_CLICKHandler(): void {
    this.router.navigate(['/kymw/9011'], {});
  }
  public eventKYMW1003_CLICKHandler(): void {
    this.router.navigate(['kymw/1003']);
  }

  public eventKYMW0b00_CLICKHandler() {
    // 画像検索画面を呼び出す
    const componentRef = this.dialogService.openModal(KYMW0B00Component);
    const instance = componentRef.componentInstance as KYMW0B00Component;
    instance.parent = this;
    instance.kymw0B00Model = new KYMW0B00Model();
    const vo: KYMW0B00InputModel = {
      processDiv: '0',
      c2pfSearchVisibleFlg: '1'
    }
    instance.setInterfaceParam(vo);
    instance.setKYMW0B00Parameter = (outputVO: KYMW0B00OutputModel) => {
      console.log(outputVO);
    };
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  // 企画連絡承認画面を呼び出す
  public eventKYMW1317_CLICKHandler() {
    const componentRef = this.dialogService.openModal(KYMW1317Component);
    const instance = componentRef.componentInstance as KYMW1317Component;
    instance.parent = this;
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  // 商品仕様取込
  public eventKYMW1108_CLICKHandler() {
    const componentRef = this.dialogService.openModal(KYMW1108Component);
    const instance = componentRef.componentInstance as KYMW1108Component;
    instance.parent = this;
    const vo: KYMW1108InputModel = {
      processFlag: '0',
      newGoodsNum: 2,
      updateSingleGoodsNum: 1,
      selectableGoodsNum: 3,
      selectableEBaseGoodsList: [{
        eBaseSpecCode: '0001',
        janCode: '1234567',
        goodsName: '名前',
        standardName: 'なまえ',
        containNum: 1,
        makerName: 'メーカー'      
      }]
    }
    instance.setInterfaceParam(vo);
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  public eventKYMW1319_CLICKHandler() {
    const componentRef = this.dialogService.openModal(KYMW1319Component);
    const instance = componentRef.componentInstance as KYMW1319Component;
    instance.parent = this;
    const vo: KYMW1319InputVO = {
      orderCode: '2023280',
      startOrderCode: '',
      endOrderCode: '', 
      mediumType: '001',
      mediumName: 'ハピデリ',
      pcode: 'P0001091',
      guideGoodsName: '青首大根',
      progressWorkNum: '',
      editLockFlag: '1',
      bundleCatalogFlag: '1',
      bundleCatalogRoundName: '束ね企画名',
    }
    instance.setInterfaceParam(vo);
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  public eventKYMW0906Add_CLICKHandler() {
    const componentRef = this.dialogService.openModal(KYMW0906Component);
    const instance = componentRef.componentInstance as KYMW0906Component;
    instance.parent = this;
    const vo = new KYMW0906InputModel();
    // モード：追加
    vo.mode = KYMW0906InputModel.MODO_ADD;
    // 登録済みの配達企画回・アイテムコードの組み合わせリスト
    vo.registeredDeliveryCatalogAndItemCodeList = [
      {delivCatalog: '20231001', itemCode: '4430409'},
      {delivCatalog: '20231004', itemCode: '1234567'}
    ];
    // 束ね企画回の終了企画回：どこから持ってくるのかは要調査
    vo.bundleEndDeliveryOrder = '2023290';
    // kymw0900Model.itemCodeList を渡す想定
    // 他にkymw0900Modelでアイテムコードのリストがなさそうという理由だけなので間違ってるかも
    vo.itemCodeList = [
      {ItemCode: '4430409'},
      {ItemCode: '4430410'},
    ];
    // 注文コード：どこから持ってくるのかは要調査
    vo.orderNum = '123';
    // 会員タブの価格一覧でアイムコードを選択している生協のリスト、のはずだが間違ってるかも
    vo.enableCoopByItemCodeList = [
      {DelivCatalog: '20231001',
        ItemCode: '1234567',
        DisableCoopCodeList: ['142', '163']},
      {DelivCatalog: '20231001',
        ItemCode: '1234567',
        DisableCoopCodeList: ['240', '210']}
    ]
    // kymw0900Model.preOrderOrderNumQuotaCodeListを渡す想定
    vo.preOrderOrderNumQuotaCodeList = [
      {OrderNumQuotaCode: '123', OrderNumQuotaCodeName: '123:aaa'},
      {OrderNumQuotaCode: '456', OrderNumQuotaCodeName: '456:bbb'},
      {OrderNumQuotaCode: '789', OrderNumQuotaCodeName: '789:ccc'},
    ]
    // kymw0900Model.supplyPriceStandardを渡す想定
    vo.supplyPriceStandard = '1000';
    // kymw0900Model.goodsPlanNumListを渡す想定
    // deleteFlgは生協チェックボックス操作時に変更する必要があるので持たせているがどこから持ってくるものなのかは要調査
    vo.goodsPlanNumList = [
      {coopName: 'いばらき',
      coopCode: '142',
      planNum: 0,
      registFlg: '0',
      deleteFlg: '0',
      checked: true},
      {coopName: 'とちぎ',
      coopCode: '163',
      planNum: 0,
      registFlg: '0',
      deleteFlg: '0',
      checked: true},
      {coopName: 'ぐんま',
      coopCode: '185',
      planNum: 0,
      registFlg: '0',
      deleteFlg: '0',
      checked: false,},
      {coopName: 'ちば',
      coopCode: '240',
      planNum: 0,
      registFlg: '0',
      deleteFlg: '0',
      checked: false},
      {coopName: 'さいたま',
      coopCode: '210',
      planNum: 0,
      registFlg: '0',
      deleteFlg: '0',
      checked: false},
      {coopName: 'とうきょう',
      coopCode: '302',
      planNum: 0,
      registFlg: '0',
      deleteFlg: '0',
      checked: false},
      {coopName: 'ながの',
      coopCode: '515',
      planNum: 0,
      registFlg: '0',
      deleteFlg: '0',
      checked: false},
      {coopName: 'にいがた',
      coopCode: '451',
      planNum: 0,
      registFlg: '0',
      deleteFlg: '0',
      checked: false},
      {coopName: '合計',
      coopCode: '',
      planNum: 0,
      registFlg: '0',
      deleteFlg: '0',
      checked: false}
    ];

    instance.setInterfaceParam(vo);
    instance.setKYMW0906Parameter = (outputVO: KYMW0906OutputModel) => {
      console.log(outputVO);
    };
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  public eventKYMW0906Detail_CLICKHandler() {
    const componentRef = this.dialogService.openModal(KYMW0906Component);
    const instance = componentRef.componentInstance as KYMW0906Component;
    instance.parent = this;
    const vo = new KYMW0906InputModel();
    // モード：詳細
    vo.mode = KYMW0906InputModel.MODO_DETAIL;
    // モード：閲覧（閲覧ユーザーもしくはロック非解除時、この場合はKYMW0900の追加ボタンは非活性の想定）
    // vo.mode = KYMW0906InputModel.MODO_READ_ONLY;
    // 登録済みの配達企画回・アイテムコードの組み合わせリスト
    vo.registeredDeliveryCatalogAndItemCodeList = [
      {delivCatalog: '20231001', itemCode: '4430409'},
      {delivCatalog: '20231004', itemCode: '1234567'}
    ];
    // 束ね企画回の終了企画回：どこから持ってくるのかは要調査
    vo.bundleEndDeliveryOrder = '2023290';
    // 選択行の配達企画回を渡す想定
    vo.deliveryCatalog = '20231002';
    // 選択行のアイテムコードを渡す想定
    vo.selectedItemCode = '4430409';
    // kymw0900Model.itemCodeList を渡す想定
    // 他にkymw0900Modelでアイテムコードのリストがなさそうという理由だけなので間違ってるかも
    vo.itemCodeList = [
      {ItemCode: '4430409'},
      {ItemCode: '4430410'},
    ];
    // 会員タブの価格一覧でアイムコードを選択している生協のリスト、のはずだが間違ってるかも
    vo.enableCoopByItemCodeList = [
      {DelivCatalog: '20231001',
        ItemCode: '1234567',
        DisableCoopCodeList: ['142', '163']},
      {DelivCatalog: '20231001',
        ItemCode: '1234567',
        DisableCoopCodeList: ['240', '210']}
    ]
    // 選択行のpreOrderNumQuotaCodeを渡す想定
    vo.preOrderNumQuotaCode = '123';
    // kymw0900Model.preOrderOrderNumQuotaCodeListを渡す想定
    vo.preOrderOrderNumQuotaCodeList = [
      {OrderNumQuotaCode: '123', OrderNumQuotaCodeName: '123:aaa'},
      {OrderNumQuotaCode: '456', OrderNumQuotaCodeName: '456:bbb'},
      {OrderNumQuotaCode: '789', OrderNumQuotaCodeName: '789:ccc'},
    ]

    // 選択行の配達企画回
    vo.deliveryCatalog = '20231001';
    // 選択行のアイテムコード
    vo.selectedItemCode = '1234567';
    // 選択行の注文コードを渡す想定
    vo.orderNum = '123';
    // 選択行の配達企画曜日を渡す想定
    vo.delivMonday = false;
    vo.delivTuesday = false;
    vo.delivWednesday = true;
    vo.delivThursday = true;
    vo.delivFriday = true;
    // kymw0900Model.preOrderGoodsNameを渡す想定
    vo.preOrderGoodsName = 'ＷＷＷＷＷＷＷＷＷＷＷＷＷＷＷ';
    // kymw0900Model.preOrderGoodsNameKanaを渡す想定
    vo.preOrderGoodsNameKana = 'ﾜﾜﾜﾜﾜﾜﾜﾜﾜﾜﾜﾜﾜﾜﾜ';
    // kymw0900Model.preOrderStandardNameを渡す想定
    vo.preOrderStandardName = 'ＸＸＸＸＸＸＸ';
    // kymw0900Model.preOrderStandardNameKanaを渡す想定
    vo.preOrderStandardNameKana = 'XXXXXXXXXX';
    // kymw0900Model.setPreOrderTypeを渡す想定
    vo.setPreOrderType = true;
    // kymw0900Model.supplyPriceStandardを渡す想定
    vo.supplyPriceStandard = '1000';
    // kymw0900Model.discountTypeを渡す想定
    vo.discountType = '1';
    // kymw0900Model.discountUnitPriceを渡す想定
    vo.discountUnitPrice = '10';
    // kymw0900Model.discountRateを渡す想定
    vo.discountRate = '';
    // kymw0900Model.discountSupplyUnitPriceを渡す想定
    vo.discountSupplyUnitPrice = '990';
    // kymw0900Model.preOrderPointsを渡す想定
    vo.preOrderPoints = '15';
    // kymw0900Model.goodsPlanNumListを渡す想定
    // deleteFlgは生協チェックボックス操作時に変更する必要があるので持たせているがどこから持ってくるものなのかは要調査
    vo.goodsPlanNumList = [
      {coopName: 'いばらき',
      coopCode: '142',
      planNum: 0,
      registFlg: '0',
      deleteFlg: '0',
      checked: false},
      {coopName: 'とちぎ',
      coopCode: '163',
      planNum: 0,
      registFlg: '0',
      deleteFlg: '0',
      checked: false},
      {coopName: 'ぐんま',
      coopCode: '185',
      planNum: 100,
      registFlg: '0',
      deleteFlg: '0',
      checked: true,},
      {coopName: 'ちば',
      coopCode: '240',
      planNum: 200,
      registFlg: '0',
      deleteFlg: '0',
      checked: true},
      {coopName: 'さいたま',
      coopCode: '210',
      planNum: 0,
      registFlg: '0',
      deleteFlg: '0',
      checked: false},
      {coopName: 'とうきょう',
      coopCode: '302',
      planNum: 0,
      registFlg: '0',
      deleteFlg: '0',
      checked: false},
      {coopName: 'ながの',
      coopCode: '515',
      planNum: 0,
      registFlg: '0',
      deleteFlg: '0',
      checked: false},
      {coopName: 'にいがた',
      coopCode: '451',
      planNum: 0,
      registFlg: '0',
      deleteFlg: '0',
      checked: false},
      {coopName: '合計',
      coopCode: '',
      planNum: 0,
      registFlg: '0',
      deleteFlg: '0',
      checked: false}
    ];

    instance.setInterfaceParam(vo);
    instance.setKYMW0906Parameter = (outputVO: KYMW0906OutputModel) => {
      console.log(outputVO);
    };
    instance.closeFunction = () => {
      componentRef.close();
    };
  }
}
